import { render, staticRenderFns } from "./Relojes.vue?vue&type=template&id=5add9090"
import script from "./Relojes.vue?vue&type=script&lang=js"
export * from "./Relojes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports